import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "grid grid-cols-2 gap-x-4 -mb-5" };
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { WidgetShell } from "@eudonet/opal";
import FieldResolver from "./FieldResolver.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'GenericBlock',
    props: {
        block: {}
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const sortedFields = computed(() => [...props.block.fields].sort((a, b) => a.order - b.order));
        // Block-scoped values for visibility condition evaluation.
        const blockValues = computed(() => Object.fromEntries(props.block.fields.map((f) => [f.key, f.value])));
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(WidgetShell), {
                header: _unref(t)(__props.block.label)
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedFields.value, (field) => {
                            return (_openBlock(), _createBlock(FieldResolver, {
                                key: field.key,
                                field: field,
                                "block-values": blockValues.value,
                                "onUpdate:modelValue": ($event) => (field.value = $event)
                            }, null, 8 /* PROPS */, ["field", "block-values", "onUpdate:modelValue"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["header"]));
        };
    }
});
